export const apiDateFormat = 'YYYY-MM-DDTHH:mm:ssZ[Z]';
